import React, { ReactNode } from "react"
import styled from "styled-components"

type Props = {
  checked: boolean
  onChange?: () => void
  id?: string
}

const CheckBoxLabelContainer = styled.div`
  padding: 8px;
  display: flex;
  flex-direction: row;
  gap: 16px;
`

export function Checkbox({ checked, onChange = () => {}, id = "" }: Props) {
  return (
    <input
      id={id}
      checked={checked}
      onChange={onChange}
      style={{ cursor: "pointer", minWidth: "15px" }}
      type="checkbox"
      autoComplete="off"
    />
  )
}

export const CheckboxWithLabel = ({
  checked,
  onChange,
  id,
  children,
}: Props & { children: ReactNode }) => (
  <CheckBoxLabelContainer>
    <Checkbox id={id} checked={checked} onChange={onChange} />
    <label htmlFor={id}>{children}</label>
  </CheckBoxLabelContainer>
)
